import React, { useEffect, useState, useContext } from 'react'
import useAxiosFetch from '../Hooks/useAxiosFetch';
import ProgressIndicator from '../Indicator/ProgressIndicator';
import { useNavigate } from 'react-router-dom';
import Title from '../Title/Title';
import { BorderAll, Flag, Padding } from '@mui/icons-material';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import DataContext from '../Context/DataContext';
import FabBottom from '../Fab/fabbotton';
import ProgramDetailDialog from './programdetaildialog';
import { tr } from 'date-fns/locale';
import BottomPadding from '../BottomPadding/bottompadding';

const Programs = () => {
    const {data, fetchError, isLoading} = useAxiosFetch("https://sasyavatagro.com/repos/api/dairyfarm/getprogramslist");
    const { items } = useContext(DataContext);
    const [loadingstate, setLoadingState] = useState(true);

    let navigate = useNavigate();
    
    const [dataItems, setDataItems]= useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

//    console.log(data);

  useEffect(()=>{
      try{
//        console.log(isLoading);
        if(data.status===200){
          setDataItems(data.data)
        }
      } catch (err){
        // console.log(fetchError)
      } finally{
//        console.log(data["data"] );
      }
}, [loadingstate, data]);

    useEffect(()=>{
      setLoadingState(false);    
//      console.log(items);
    }, [isLoading]);

    const handlefabclick=(data)=>{
//    setIsModalOpen(true)
//    console.log(data);
    setIsModalOpen(true);
}

const handleFormSubmit = async  (data) =>  {
//  console.log("Collected Form Data:", data.title);
  setLoadingState(true);
  const API_URL = `https://sasyavatagro.com/repos/api/dairyfarm/addprogram?title=${data.title}&description=${data.description}&participatingcows=${data.participatingcows}`;
            try{
              const response = await fetch(API_URL);
              if (!response.status) throw Error("Failed to fetch data");
              let result = await response.json();
              console.log(result);
              setLoadingState(false);
              if(result >0){
                const progdata = await fetch("https://sasyavatagro.com/repos/api/dairyfarm/getprogramslist");
                 const data = await progdata.json();   
                 console.log(data)
                 setDataItems(data);            
            }
            }
            catch (err) {
              console.log(err);
            }
            finally {

            }    
  // Example: navigate('/success', { state: data });

};

    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };

    function OpenPrograms (data) {
      navigate("/ProgramsList", {state: data});
//      console.log(data);
//      console.log(items);

//      navigate("/ProgramsList", { state: { data: listdata } });
//navigate("/cowlist", { replace: false });

    }

      return (
    <>
    <Title title={"Programs"} />
    {loadingstate && <ProgressIndicator />}
    {!loadingstate && 
    <div style={{ maxWidth: '100%', backgroundColor:'cornsilk' }} aria-label="customized table">      
            <FabBottom handleClick={handlefabclick}/>
            <ProgramDetailDialog 
              open={isModalOpen} 
              handleClose={() => setIsModalOpen(false)} 
              onSubmit={handleFormSubmit}
            />
        {
            dataItems.map((item) => (
                
                    <div key={item.ProgramId} style={{display:'flex', justifyContent:'space-evenly', paddingTop:'5px',
                        backgroundColor:'lightblue', paddingBottom: '10px', margin:'10px', BorderAll}}>                          
                            <div style={{textAlign:'left', width:'50%'}}>{item.Title} </div><div style={{textAlign:'right'}}>{item.CreateDate.split('T')[0]}</div>
                    <button onClick={()=> OpenPrograms(item)} style={{width:'55px', backgroundColor:'lightpink', borderRadius:'10px'}} >Details</button>                    
                    </div>
                
            ))
        }
        
    </div>
    }
    <BottomPadding pad={'120px'} />
    {/* <div style={{position:'absolute', bottom:'40px', zIndex:'1', height:'60px', width:'100vw', backgroundColor:'#F2EBEB'}}>
    </div> */}
    </>
    );

}

export default Programs;